const OFFER_MARKER_CLASSNAME = 'kel-shopware-offer-marker';

export { OFFER_MARKER_CLASSNAME };
